<info-modal [title]="title" (onOk)="ok()">
	<loading [isLoad]="!details"></loading>

	<table class="table table-sm">
		<thead>
			<tr>
				<th>
					{{ 'adminstat.common.Date' | translate }}
				</th>
				
				<th>
					{{ 'adminstat.template.template' | translate }}
				</th>
				
				<th>
					$
				</th>
				
				<th>
					{{ 'adminstat.common.User' | translate }}
				</th>
				
				<th>
					{{ 'adminstat.common.Site' | translate }}
				</th>
			</tr>
		</thead>
		
		<tbody>
			<tr *ngFor="let item of details">
				<td>
					{{item.date}}
				</td>
				
				<td>
					{{item.templateId}}
				</td>
				
				<td>
					{{item.money}}
				</td>
				
				<td>
					<gotosupport [value]="item.email"></gotosupport>
				</td>
				
				<td>
					<site_info [siteUrl]="item.site"></site_info>
				</td>
			</tr>
		</tbody>
	</table>
</info-modal>
